import { useMemo } from "react";

import { useScreenSizes } from "./useScreenSizes";

export const useMobileWidth = () => {
  const { width, isCalculating } = useScreenSizes();
  const mobileBreakpoint = 480;
  // Always call hooks in a consistent order. Compute with a safe fallback
  const isMobileScreen = useMemo(() => width <= mobileBreakpoint, [width]);

  return { isMobileScreen, isCalculating, mobileBreakpoint };
};
